module.exports = __webpack_public_path__ + "media/images/app/visitors/couture/hero-58888cafad1802344a4e58f005328b0a.webp";